import api from './api';

type ApiEnvelope<T> = {
  success: boolean;
  data: T;
  message?: string;
};

function unwrapData<T>(response: any, fallback: T): T {
  const payload = response?.data ?? response?.result ?? response ?? fallback;
  return payload === null || payload === undefined ? fallback : (payload as T);
}

function envelope<T>(response: any, fallback: T): ApiEnvelope<T> {
  const data = unwrapData(response, fallback);
  return {
    success: response?.success !== false,
    data,
    message: response?.message,
  };
}

function envelopeArray<T = any>(response: any): ApiEnvelope<T[]> {
  const data = unwrapData<any>(response, []);
  const payload = response?.items ?? response?.runs ?? response?.templates ?? data?.items ?? data?.runs ?? data?.templates ?? data;
  return {
    success: response?.success !== false,
    data: Array.isArray(payload) ? payload : [],
    message: response?.message,
  };
}

export async function listPipelineTemplates() {
  const response = await api.get<{ success: boolean; data: any[] }>(`/juben/pipelines/templates`);
  return envelopeArray(response);
}

export async function runPipeline(payload: {
  template_id: string;
  user_input: string;
  user_id: string;
  session_id: string;
  project_id?: string;
}) {
  const response = await api.post<{ success: boolean; data: any }>(`/juben/pipelines/run`, payload);
  return envelope(response, {});
}

export async function listPipelineRuns(projectId?: string) {
  const response = await api.get<{ success: boolean; data: any[] }>(`/juben/pipelines/runs`, projectId ? { project_id: projectId } : undefined);
  return envelopeArray(response);
}

export async function getPipelineRun(runId: string) {
  const response = await api.get<{ success: boolean; data: any }>(`/juben/pipelines/runs/${runId}`);
  return envelope(response, {});
}
